var JobModel = BaseObjectModel.extend({
  className: "JobModel",

  /**
  * Загружает события блока типового маршрута.
  *
  * @method WebAccess.models.JobModel#loadEvents
  * @param {object} standardRouteEvents События блока типового маршрута
  * @since 5.7.0
  */
  loadEvents: function (standardRouteEvents) {
    var me = this;
    var currentStandardRouteEvents = standardRouteEvents[this.LeadTaskStandartRouteCode];
    // Найдем нужный объект (для текущего ТМ-а).
    if (typeof currentStandardRouteEvents != 'undefined') {
      // ... и только для конкретного блока. Если подходящего (по ИД) нет, то не биндим.
      if (typeof currentStandardRouteEvents.blocks[this.WorkflowBlockID] != 'undefined') {
        $.each(currentStandardRouteEvents.blocks[this.WorkflowBlockID], function (eventName, eventCallback) {
          me.bind(eventName, eventCallback);
        });
      }
    }
  },

  /**
  * Устанавливает метод, который вызывается для всех заданий по типовому маршруту перед запросом параметров.
  *
  * @method WebAccess.models.JobModel#bindBeforeAskingCommonEvent
  * @param {object} commonEvent Функция, вызываемая для всех заданий по типовому маршруту
  * @since 5.7.0
  */
  bindBeforeAskingCommonEvent: function (commonEvent) {
    var me = this;
    if ($.isFunction(commonEvent)) {
      me.bind('BeforeParamAsking', commonEvent);
    }
  },

  /**
  * Выполняет задание с результатом выполнения.
  *
  * @method WebAccess.models.JobModel#performResult
  * @param {object} performResult Результат выполнения
  * @since 5.7.0
  */
  performResult: function (performResult) {
    Core.toolBars.job.performResult(performResult);
  },

  /**
  * Выполняет задание по коду результата выполнения.
  *
  * @method WebAccess.models.JobModel#performByResultCode
  * @param {string} performResultCode Код результата выполнения
  * @since 5.8.1
  */
  performByResultCode: (performResultCode) => {
    Core.toolBars.job.performByResultCode(performResultCode);
  },

  /**
  * Выполняет задание по имени результата выполнения.
  *
  * @method WebAccess.models.JobModel#performByResultName
  * @param {string} performResultName Имя результата выполнения
  * @since 5.8.1
  */
  performByResultName: (performResultName) => {
    Core.toolBars.job.performByResultName(performResultName);
  },

  /**
 * Выполняет задание.
 *
 * @method WebAccess.models.JobModel#perform
 * @since 5.8.1
 */
  perform: () => {
    Core.toolBars.job.perform();
  },

  /**
  * Возвращает результаты выполнения задания.
  *
  * @method WebAccess.models.JobModel#performResults
  * @return {Core.jobs.performResults} Объект типа Core.jobs.performResults – результаты выполнения задания.
  * @since 5.8.1
  */
  performResults: () => {
    return Core.jobs.performResults;
  }
});

/**
* Тип задания.
* @enum {integer} JOB_KIND
* @readonly
* @global
*/
var JOB_KIND = {
  /** Задача */
  JOB: 0,
  /** Уведомление  */
  NOTICE: 1,
  /** Задание-контроль */
  CONTROLJOB: 2
};